module.exports = __webpack_public_path__ + "img/MUADEE1.218fd36a.svg";